export default __webpack_public_path__ + "static/media/2258_ox_brand_blue_pos_rect.595ca68d.png";